var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancerCoverChecklist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 558,
    viewBox: "0 0 315 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7455_9991)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7455_9991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 372,
    height: 558
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372 0H0V558H372V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7455_9991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.814 167.184C230.284 162.741 257.936 163.998 287.981 175.148C343.475 211.821 250.386 255.178 231.787 262.643C213.188 270.108 142.973 201.326 145.176 192.271C147.378 183.217 157.618 172.684 197.814 167.184Z",
    fill: "#C8202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.635 130.641L268.985 259.545L201.947 257.655L200.266 135.968L253.635 130.641Z",
    fill: "#F09A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42 199.107L201.078 255.812L266.974 245.964L259.689 179.761L201.42 199.107Z",
    fill: "#E77B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.286 363.75C455.819 295.901 452.338 292.341 459.091 265.484C465.845 238.627 324.339 300.987 257.874 313.44C152.03 333.271 169.299 432.503 218.023 438.076C309.83 448.576 311.975 408.687 369.286 363.75Z",
    fill: "#ED1B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27 284.29C296.228 320.157 300.445 366.303 287.664 396.018C261.723 491.061 208.7 440.452 187.974 401.108C145.687 320.84 135.724 181.923 146.428 192.049C167.531 212.014 202.366 255.117 303.942 197.061C309.704 193.767 300.947 237.245 298.27 284.29Z",
    fill: "#ED1B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.552 407.681C269.907 448.959 311.88 398.053 435.172 298.273C315.336 450.308 236.591 480.903 187.981 426.927C160.02 395.878 153.368 309.2 146.375 263.503C158.786 287.291 165.832 376.581 210.552 407.681Z",
    fill: "#C8202F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.171 154.367C286.063 133.608 168.674 87.3477 159.492 85.2236C139.701 131.752 98.0863 271.884 71.4808 310.525C51.0858 340.148 44.231 343.971 29.0469 360.128L210.609 431.053C220.548 425.372 227.391 423.736 247.755 385.884C268.119 348.033 324.61 195.566 338.171 154.367Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.775 410.228C191.66 420.072 201.084 424.946 210.621 431.056L29.06 360.131C28.0255 359.727 24.7004 356.639 19.6766 347.522C14.6526 338.406 14.3828 330.549 14.8758 327.761L176.264 390.805C177.323 394.2 182.02 406.29 184.775 410.228Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.456 159.246C225.956 163.131 209.227 168.622 186.533 159.261C168.238 207.29 179.643 237.539 195.465 253.728L195.464 253.731C195.465 253.731 195.466 253.731 195.467 253.73C195.467 253.731 195.467 253.731 195.467 253.731V253.73C217.633 252.012 246.691 237.176 264.987 189.147C242.314 181.227 232.905 165.778 231.458 159.249L231.46 159.243C231.46 159.244 231.459 159.245 231.458 159.245C231.457 159.245 231.457 159.244 231.457 159.243L231.456 159.246Z",
    fill: "#B474B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.846 173.991C226.986 178.573 234.733 189.71 251.342 195.539C240.949 222.826 217.205 238.069 201.089 238.981L201.088 238.983C189.355 227.465 182.075 200.403 192.47 173.115C209.114 179.953 221.887 176.632 225.842 173.991L225.844 173.986C225.845 173.988 225.845 173.989 225.845 173.989L225.846 173.989L225.846 173.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.263 203.954L223.184 191.034L216.384 188.444L211.463 201.364L198.543 196.442L195.953 203.242L208.873 208.163L203.951 221.083L210.751 223.674L215.673 210.754L228.592 215.676L231.182 208.875L218.263 203.954Z",
    fill: "#B474B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.339 244.844C249.553 254.784 238.426 259.771 228.487 255.985C218.547 252.199 213.558 241.073 217.345 231.133C221.131 221.193 232.258 216.205 242.198 219.991C252.136 223.777 257.125 234.904 253.339 244.844Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.836 243.261C240.884 240.51 239 238.639 237.24 237.2L238.976 232.644C239.762 233.231 240.247 234.04 240.45 234.959L242.855 234.265C242.313 232.784 241.44 231.538 239.802 230.601L240.641 228.397L238.374 227.533L237.55 229.695C234.944 229.088 232.71 230.16 231.91 232.259C230.942 234.8 232.728 236.611 234.441 237.985L232.482 243.128C231.431 242.416 230.77 241.371 230.499 240.065L227.922 240.959C228.552 242.714 229.633 244.231 231.607 245.296L230.696 247.69L232.963 248.553L233.875 246.16C236.702 246.755 239.036 245.361 239.836 243.261ZM237.527 242.382C237.11 243.473 236.044 244.125 234.657 243.981L236.361 239.509C237.314 240.353 237.95 241.268 237.527 242.382ZM234.222 233.069C234.597 232.081 235.566 231.56 236.816 231.748L235.321 235.674C234.423 234.876 233.838 234.076 234.222 233.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.962 168.186C254.418 168.099 268.299 147.653 273.947 136.73L279.033 129.188L284.147 130.634C285.137 118.968 282.324 113.377 270.938 108.905C266.219 107.052 262.349 110.092 261.405 109.278C260.461 108.462 256.444 104.375 252.17 101.578C247.897 98.7807 243.469 101.216 242.407 101.641C241.559 101.981 240.431 98.9453 239.27 97.4982C235.745 93.1021 231.84 93.5001 230.962 93.1895C226.996 93.4378 226.64 95.7173 226.011 95.1732C225.382 94.6292 224.505 92.4213 219.612 89.645C214.718 86.8688 207.243 93.2704 205.881 95.6717C204.519 98.0729 197.044 121.983 198.036 129.585C200.905 135.436 207.527 137.784 210.697 136.053C210.868 136.647 209.146 141.456 214.061 145.705C218.807 149.804 223.318 148.002 225.367 148.728C224.049 157.705 236.189 159.169 238.675 156.849C239.793 165.417 244.392 168.294 249.962 168.186Z",
    fill: "#F09A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.192 153.049C237.087 157.491 242.05 166.5 241.557 162.701C241.059 158.899 247.08 140.492 258.235 113.031C253.725 121.502 239.297 148.607 238.192 153.049Z",
    fill: "#E77B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.426 144.549C221.623 152.245 230.436 158.322 230.165 156.252C229.668 152.45 228.181 141.048 238.839 109.785C234.33 118.256 225.979 140.284 224.426 144.549Z",
    fill: "#E77B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.687 136.043C207.921 147.169 225.428 152.147 224.934 148.349C206.944 139.553 217.709 125.245 225.099 101.277C220.591 109.749 211.791 131.6 210.687 136.043Z",
    fill: "#E77B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.461 123.753C193.821 134.36 211.196 139.854 210.703 136.056C197.457 131.358 198.337 122.002 205.737 98.042C201.229 106.512 197.565 119.311 196.461 123.753Z",
    fill: "#E77B5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.446 289.8L217.266 278.184L213.484 280.1L220.391 295.587L252.804 279.166L251.078 275.294L222.446 289.8Z",
    fill: "#B474B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.695 331.334L202.516 319.72L198.734 321.635L205.641 337.122L238.054 320.7L236.327 316.828L207.695 331.334Z",
    fill: "#B474B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.945 372.881L187.766 361.265L183.984 363.181L190.89 378.669L223.304 362.247L221.577 358.375L192.945 372.881Z",
    fill: "#B474B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.122 253.599C124.575 252.325 125.518 251.495 126.227 251.747L175.075 269.093C175.785 269.345 175.993 270.583 175.541 271.858C175.088 273.132 174.145 273.961 173.436 273.709L124.588 256.364C123.878 256.112 123.67 254.873 124.122 253.599Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.194 292.831C110.646 291.558 111.428 290.671 111.937 290.851L147.02 303.31C147.53 303.49 147.577 304.671 147.125 305.945C146.672 307.219 145.891 308.107 145.382 307.925L110.298 295.468C109.788 295.287 109.741 294.105 110.194 292.831Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.26 332.076C96.713 330.802 97.6188 329.96 98.2828 330.196L143.987 346.424C144.651 346.66 144.822 347.885 144.37 349.16C143.917 350.434 143.011 351.276 142.347 351.041L96.6432 334.812C95.9801 334.576 95.8081 333.35 96.26 332.076Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.224 242.06C128.676 240.785 129.447 239.894 129.943 240.071L185.846 259.922C186.343 260.098 186.379 261.275 185.926 262.549C185.474 263.823 184.704 264.714 184.207 264.538L128.304 244.688C127.807 244.511 127.771 243.334 128.224 242.06Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.285 281.299C114.738 280.025 115.508 279.134 116.006 279.31L171.908 299.161C172.406 299.338 172.442 300.515 171.989 301.789C171.537 303.063 170.766 303.953 170.27 303.778L114.366 283.927C113.87 283.75 113.833 282.574 114.285 281.299Z",
    fill: "#783780"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.349 320.533C100.801 319.259 101.572 318.368 102.068 318.545L157.971 338.395C158.468 338.571 158.504 339.749 158.052 341.023C157.599 342.297 156.829 343.187 156.332 343.011L100.429 323.16C99.9319 322.985 99.8957 321.807 100.349 320.533Z",
    fill: "#783780"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7455_9991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 372,
    height: 558,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerCoverChecklist);
export default __webpack_public_path__ + "static/media/cancer-cover-checklist.42e652e85f0648719df1ab52021247c7.svg";
export { ForwardRef as ReactComponent };